const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, SelectControl, TextControl } = wp.components;

const Inspector = ({ attributes, setAttributes }) => {
  const {
    variant,
    titleTag,
    padded,
    isParent,
    containerized,
    color,
    textColor,
    hasMargin,
    border,
    hasId,
    idAccordion,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <ToggleControl
          label="Deseja adicionar container neste accordion?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />

        <ToggleControl
          label="Este item é o elemento pai?"
          checked={isParent}
          onChange={() => setAttributes({ isParent: !isParent })}
        />

        <ToggleControl
          label="O conteúdo dentro deste acordeon deve ter margens laterais?"
          checked={padded}
          onChange={() => setAttributes({ padded: !padded })}
        />

        <SelectControl
          label="Selecione o estilo desejado"
          title="Selecione o estilo desejado"
          value={variant}
          options={[
            { label: 'Sem formatação', value: 'default' },
            { label: 'Fundo Azul', value: 'blue' },
            { label: 'Com borda', value: 'bordered' },
            { label: 'Com descrição', value: 'withDescription' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        {variant == 'withDescription' && (
          <SelectControl
            label="Selecione a cor da borda"
            title="Selecione a cor da borda"
            value={color}
            options={[
              { label: 'Azul', value: 'borderBlue' },
              { label: 'Laranja', value: 'borderOrange' },
              { label: 'Preta', value: 'borderBlack' },
              { label: 'Verde', value: 'borderGreen' },
            ]}
            onChange={(position) => setAttributes({ color: position })}
          />
        )}

        {variant == 'default' && (
          <>
            <SelectControl
              label="Selecione a cor do texto"
              title="Selecione a cor do texto"
              value={textColor}
              options={[
                { label: 'Cinza escuro', value: 'textGrey' },
                { label: 'Preto', value: 'textBlack' },
                { label: 'Branco', value: 'textWhite' },
                { label: 'Azul Anil', value: 'textBlueAnil' },
              ]}
              onChange={(position) => setAttributes({ textColor: position })}
            />

            <ToggleControl
              label="Adicionar margin ao título e a seta"
              checked={hasMargin}
              onChange={() => setAttributes({ hasMargin: !hasMargin })}
            />

            <ToggleControl
              label="Quando o accordion estiver aberto a borda será após o conteúdo ?"
              checked={border}
              onChange={() => setAttributes({ border: !border })}
            />
          </>
        )}

        <SelectControl
          label="Selecione qual tag quer usar para o título"
          title="Selecione qual tag quer usar para o título"
          value={titleTag}
          options={[
            { label: 'H1', value: 'h1' },
            { label: 'H2', value: 'h2' },
            { label: 'H3', value: 'h3' },
            { label: 'H4', value: 'h4' },
            { label: 'H5', value: 'h5' },
            { label: 'H6', value: 'h6' },
            { label: 'p', value: 'p' },
          ]}
          onChange={(position) => setAttributes({ titleTag: position })}
        />

        <ToggleControl
          label="Adicionar id ao container?"
          checked={hasId}
          onChange={() => setAttributes({ hasId: !hasId })}
        />

        {hasId && (
          <TextControl
            label="Informe o ID do accordion"
            value={idAccordion}
            onChange={(idAccordion) => setAttributes({ idAccordion })}
          />
        )}
      </PanelBody>
    </InspectorControls>
  );
};

export default Inspector;
